module.exports = __webpack_public_path__ + "img/图片4.bf1d4e9a.png";